module.exports = __webpack_public_path__ + "static/img/cn.32e1ae8b.jpg";